module.exports = __webpack_public_path__ + "img/pin-input.fe99a727.png";